import { useCallback, useState } from 'react';

import { ITaskInfo } from '@/entities/task/model/client';
import { WeeklyWorkLog } from '@/types';

export const useDetailsDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState<WeeklyWorkLog | null>(null);
  const [selectedTask, setSelectedTask] = useState<ITaskInfo | null>(null);

  const showDetails = useCallback((logOrTask: WeeklyWorkLog | ITaskInfo) => {
    if ('taskKey' in logOrTask) {
      // Это WeeklyWorkLog
      setSelectedLog(logOrTask);
      setSelectedTask(null);
      setIsOpen(true);

      return;
    }

    // Это ITaskInfo
    setSelectedTask(logOrTask);
    setSelectedLog(null);
    setIsOpen(true);
  }, []);

  const hideDetails = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleExited = useCallback(() => {
    setSelectedLog(null);
    setSelectedTask(null);
  }, []);

  return {
    isOpen,
    selectedLog,
    selectedTask,
    showDetails,
    hideDetails,
    handleExited,
  };
};
